import React, { Component } from 'react';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrLightbox from 'client/components/SrLightbox';

class SrPhotoViewer extends Component {
  constructor() {
    super();

    this.state = {
      isLightboxOpen: false,
      lightBoxPhotoIndex: 0,
    };
  }

  _onToggleLightbox = () => {
    this.setState({
      isLightboxOpen: !this.state.isLightboxOpen,
    });
  }

  _goToPrevious = () => {
    const currentLightBoxPhotoIndex = this.state.lightBoxPhotoIndex;
    this.setState({
      lightBoxPhotoIndex: currentLightBoxPhotoIndex - 1,
    });
  }

  _goToNext = () => {
    const currentLightBoxPhotoIndex = this.state.lightBoxPhotoIndex;
    this.setState({
      lightBoxPhotoIndex: currentLightBoxPhotoIndex + 1,
    });
  }

  render() {
    const { lightBoxPhotoIndex, isLightboxOpen } = this.state;
    const { children, photoUrls } = this.props;

    return (
      <SrBox>
        <SrText onClick={this._onToggleLightbox} color='blue300' cursor='pointer' weight='inherit'>
          {children}
        </SrText>

        <SrLightbox
          photoUrls={photoUrls}
          currentImage={lightBoxPhotoIndex}
          isOpen={isLightboxOpen}
          onClickPrev={this._goToPrevious}
          onClickNext={this._goToNext}
          onClose={this._onToggleLightbox}
        />
      </SrBox>
    );
  }
}

SrPhotoViewer.displayName = 'SrPhotoViewer';

export default SrPhotoViewer;
